module.exports = __webpack_public_path__ + "static/media/tbi.48e6e342.jpg";